module.exports = __webpack_public_path__ + "img/model_100.b58a3089.jpg";